import React from 'react';
import { Download, Smartphone } from 'lucide-react';
import { usePWAInstall } from '../../../hooks/usePWAInstall';
import { motion } from 'framer-motion';

export function InstallButton() {
  const { isInstallable, isInstalled, handleInstall } = usePWAInstall();

  if (!isInstallable || isInstalled) return null;

  return (
    <motion.button
      whileHover={{ scale: 1.05, y: -2 }}
      whileTap={{ scale: 0.95 }}
      onClick={handleInstall}
      className="inline-flex items-center px-4 py-2.5 bg-white text-emerald-700 rounded-lg 
                 hover:bg-emerald-50 transition-all duration-200 shadow-lg font-medium
                 border border-emerald-200 hover:border-emerald-300"
    >
      <Smartphone className="h-4 w-4 mr-2" />
      <span className="hidden sm:inline">Install App</span>
      <span className="sm:hidden">Install</span>
    </motion.button>
  );
}